export const NavProductData = {
  "seo-smo": {
    title: "SEO & SMO Services",
    description:
      "Improve your website ranking with our professional SEO & SMO strategies.",
    features: [
      "Keyword Research",
      "On-Page SEO Optimization",
      "Technical SEO",
      "Social Media Optimization",
      "Monthly Performance Reports",
    ],
  },

  "content-marketing": {
    title: "Content Marketing",
    description:
      "High-quality content creation to increase engagement and conversions.",
    features: [
      "Blog Writing",
      "Website Content",
      "SEO Optimized Articles",
      "Content Strategy Planning",
    ],
  },

  "google-ads": {
    title: "Google Ads Management",
    description:
      "Drive instant traffic and leads with optimized Google Ads campaigns.",
    features: [
      "Search Campaigns",
      "Display Ads",
      "Conversion Tracking",
      "Budget Optimization",
    ],
  },

  "ppc-advertising": {
    title: "PPC Advertising",
    description:
      "Get fast results with our ROI-driven Pay Per Click advertising services.",
    features: [
      "Campaign Setup",
      "A/B Testing",
      "Ad Copy Optimization",
      "Weekly Reports",
    ],
  },
};